import { FC, useEffect, useState } from 'react';
import useDateFnsLocale from 'src/common/hooks/useDateFnsLocale';
import { formatDate } from 'src/common/utils/dateHelpers';

export type ReviewDateProps = {
  /**
   * UTC
   */
  date: string;
  className?: string;
};

/**
 * Render date (MMMM, yyyy) only on client-side to avoid hydration mismatches.
 */
const ReviewDate: FC<ReviewDateProps> = ({ date, className }) => {
  const locale = useDateFnsLocale();
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);
  return (
    <time
      dateTime={isClient ? date : ''}
      className={className}
    >
      {isClient
        ? formatDate(new Date(date), 'MMMM, yyyy', locale)
        : ' '}
    </time>
  );
};

export default ReviewDate;
